import { render, staticRenderFns } from "./team-details.vue?vue&type=template&id=d7449a78"
import script from "./team-details.vue?vue&type=script&lang=js"
export * from "./team-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports